// Copyright (c) 2024 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
require('../../global/CommonListModal.scss')
import moment from 'moment-timezone'

import Picker from 'react-mobile-picker'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import { getConvertedDate, isMaxDays } from '../../utils/helper'



function ScrollCalendar(props) {

    const[pickerDateValue, setPickerDateValue] = useState(null)
    const[btnDisabled, setBtnDisabled] = useState(props.hotel_type == '1' ? false : true)

    const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
    const CurrDate = moment(new Date()).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')
    let today = props.extend ? moment(props?.entryDateTime).format('YYYY-MM-DD HH:mm:ss') : props?.startDate ? moment(props?.startDate).format('YYYY-MM-DD HH:mm:ss') : CurrDate
    
    
    // let updatedDate = new Date(today)
    let nextXDays = function (days) {
        let dayArr = []
        for(let i = 0; i < days; i++) {
            if(props.hotel_type == '1' && i == 0) {
                continue
            }
            let date = new Date(getConvertedDate(moment(today).add(i, 'days')?.format('YYYY-MM-DD hh:mm:ss')))
            let day = moment(date).format('DD')
            let month = moment(date).format('MMM')
            let year = moment(date).format('YYYY')
            if(i === 0 && !props.isDateShow && moment(CurrDate).isSame(moment(today), 'day')) {
                dayArr.push('Today yearto '+year)
            } else {
                dayArr.push(month +' '+ day + ' yearto ' + year)
            }
            // updatedDate.setDate(updatedDate.getDate() + 1)
        }
        return dayArr
    }
    
    let days = nextXDays(props.hotel_type == '1' ? 32 : 30)

    let hours = function() {
        let hours = []
        for(let i = 1; i <= 12; i++) {
            hours.push(i < 10 ? '0'+i+'' : i+'')
        }
        return hours
    }
    let minutes = function() {
        let min = []
        for(let i = 0; i <= 59; i++) {
            min.push(i < 10 ? '0'+i+'' : i+'')
        }
        return min
    }

    const selections = [
        {mapkey: days, val: 'date'},
        {mapkey: hours(), val: 'hour'},
        {mapkey: minutes(), val: 'minutes'},
        {mapkey: ['AM', 'PM'], val: 'ampm'}
    ]
    if(props.hotel_type == '1') {
        selections.splice(-3)
    }
    const { isScrollCalendarModal, setIsScrollCalendarModal, setEntryDateTime, handleEntryTime, selectedPastDate } = props
    const [pickerValue, setPickerValue] = useState({
        date: '',
        hour: '',
        minutes: '',
        ampm: '',
    })
    // const d2 = moment(new Date(
    //     pickerValue.date.includes('Today yearto') ? `${new Date(today).toLocaleString('default', { month: 'short' })} ${new Date(today).getDate()} ${new Date(today).getFullYear()}, ${pickerValue.ampm === 'PM' ? Number(pickerValue.hour)+12 + '' : pickerValue.hour}:${Number(pickerValue.minutes) +'' }${':01'}`:
    //     `${pickerValue.date.split(' yearto ').join(' ')}, ${pickerValue.ampm === 'PM' ? Number(pickerValue.hour)+12 + '' : pickerValue.hour}:${Number(pickerValue.minutes) +'' }${':01'}`
    // )
    // // .toLocaleString('en-US',{timeZone: facilityLocData?.facility?.timezone})
    // ).format('MM-DD-YYYY hh:mm A')
    const str = pickerValue.date.replace('yearto ', '')
    // const d2 = pickerValue.date.includes('Today yearto') ?  moment(today).hours(pickerValue.hour).minutes(pickerValue.minutes).format('MM-DD-YYYY hh:mm') :
    moment(str).hours(pickerValue.hour).minutes(pickerValue.minutes).format('MM-DD-YYYY hh:mm')
    // const buttonEnableDate = pickerValue.date.includes('Today yearto') ? moment(`${moment(today).format('MM')} ${moment(today).format('DD')} ${moment(today).format('YYYY')} ${moment().hour(pickerValue.hour).format('hh')}:${moment().hour(pickerValue.minutes).format('mm')} ${moment().hour(pickerValue.hour).format('A')}`).subtract(5, 'minutes').format('MM-DD-YYYY hh:mm A') : moment(new Date(
    //     `${pickerValue.date.split(' yearto ').join(' ')}, ${pickerValue.ampm === 'PM' ? Number(pickerValue.hour)+12 + '' : pickerValue.hour}:${(Number(pickerValue.minutes) - 1) +'' }${':01'}`
    // )).format('MM-DD-YYYY hh:mm A')

    const setStringData = (opt) => {
        let strToReturn = opt.split(' yearto ')
        let day = `${strToReturn[0]} ${strToReturn[1]}`
        let isoDay = moment(day, 'MMM DD YYYY').format('dddd')
        if(props.hotel_type == '1') {
            return { date: strToReturn[0], day: isoDay }
        } else {
            return { date: strToReturn[0], day: null }
        }
        
    }
    
    const handleClick = () => {
        const{ ticketDetails, setSeletedRateBand, extend, hotel_type, startDate } = props
        const now = startDate ? moment(new Date(startDate)) : moment(new Date()).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York')
        const overnightPick = moment(pickerDateValue).set({hour: now?.format('HH'), minute: now?.format('mm'), second: '10'}).format('YYYY-MM-DD HH:mm:ss')
        const finalDate = getConvertedDate(overnightPick)
        // Bellow parameters are for date picker dates
        const maxDayFeature = isMaxDays(facilityLocData?.facility, ticketDetails, false, '', true, (hotel_type == '1' && !extend) ? finalDate : pickerDateValue, startDate ? startDate : '')
        if(maxDayFeature) {
            if(hotel_type == '1' && !extend) {
                setEntryDateTime(finalDate)
                handleEntryTime(finalDate)
            } else {
                setEntryDateTime(pickerDateValue)
                handleEntryTime(pickerDateValue)
            }
            
            setSeletedRateBand('')
            setIsScrollCalendarModal(false)
        }
    }
    useEffect(() => {
        if(props.hotel_type == '1') {
            const currentTimeinSec = props.startDate ? moment(props.startDate).format('YYYY-MM-DD hh:mm:ss A') : moment(new Date()).add(1, 'days').tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York')
            const pickerDate = (props.extend && props.entryDateTime) ? moment(props.entryDateTime, 'YYYY-MM-DD hh:mm:ss A').add(1, 'days').format('YYYY-MM-DD HH:mm:ss') : props.startDate ? moment(currentTimeinSec, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('YYYY-MM-DD HH:mm:ss') : moment(currentTimeinSec, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
            const formattedpickerDate = getConvertedDate(pickerDate)
            setPickerDateValue(formattedpickerDate)
            setBtnDisabled(false)
        }
    }, [props.entryDateTime])
    useEffect(() => {
        let pickerDtSet = new Date(getConvertedDate(moment(today)?.format('YYYY-MM-DD HH:mm:ss')))
        setEntryDateTime(
            props.hotel_type == '1' ? JSON.stringify(moment(pickerDtSet).add(1, 'days').format('MM-DD-YYYY hh:mm A')) : 
            JSON.stringify(moment(pickerDtSet).format('MM-DD-YYYY hh:mm A'))
        )
    }, [today])

    useEffect(() => {
        if(!props.extend) {
            let pickerDtSet = props.hotel_type == '1' ? new Date(getConvertedDate(moment(today).add(1, 'days')?.format('YYYY-MM-DD HH:mm:ss'))) : new Date(getConvertedDate(moment(today)?.format('YYYY-MM-DD HH:mm:ss')))
            setPickerValue({
                date: props.hotel_type == '1' ? moment(pickerDtSet).format('MMM') + ' ' + moment(pickerDtSet).format('DD') +' yearto ' + moment(pickerDtSet).year() : moment(CurrDate).isSame(moment(today), 'day') ? 'Today yearto '+ moment(pickerDtSet).year() : moment(pickerDtSet).format('MMM DD') + ' yearto ' +  moment(pickerDtSet).year(),
                hour: moment(pickerDtSet).format('hh'),
                minutes: moment(pickerDtSet).format('mm'),
                ampm: moment(pickerDtSet).format('A'),
            })
        }
    }, [isScrollCalendarModal, selectedPastDate])
    useEffect(() => {
        if(props.extend) {
            const savedFacility = JSON.parse(localStorage.getItem('faclityData'))
            const currentDate = new Date(getConvertedDate(moment(new Date()).tz(savedFacility?.facility?.timezone ? savedFacility?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
            let pickerDtSet = props.hotel_type == '1' ? new Date(getConvertedDate(moment(today).add(1, 'days')?.format('YYYY-MM-DD HH:mm:ss'))) : new Date(getConvertedDate(moment(today)?.format('YYYY-MM-DD HH:mm:ss')))
            let checkExtendDT = moment(pickerDtSet).isAfter(currentDate, 'days')
            setPickerValue({
                date: checkExtendDT ? moment(pickerDtSet).format('MMM') + ' ' + moment(pickerDtSet).format('DD') +' yearto ' + moment(pickerDtSet).year() : 'Today yearto '+ moment(pickerDtSet).year(),
                hour: moment(pickerDtSet).format('hh'),
                minutes: moment(pickerDtSet).format('mm'),
                ampm: moment(pickerDtSet).format('A'),
            })
        }
    }, [today])

    const handleCustomDatePicker = (e) => {
        setPickerValue(e)
        const dataString = new Date(e.date.split(' yearto ').join(' ').split(' ').join('-'))
        const currentTimeinSec = props.startDate ? moment(props.startDate, 'MM/DD/YYYY hh:mm A').format('YYYY-MM-DD hh:mm:ss A') : moment(new Date()).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('ss')
        const pickerDate = `${e?.date?.includes('Today yearto') ? moment(new Date()).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').set({
            hour: (e?.ampm == 'PM' && Number(e?.hour) == 12) ? '12' : (e?.ampm == 'PM') ? Number(Number(e?.hour) + 12).toFixed(0) : (e?.ampm == 'AM' && Number(e?.hour) == 12) ? '00' : e?.hour,
            minute: e?.minutes,
            second: '10'
        }).format('YYYY-MM-DD hh:mm:ss A') : moment(dataString, 'YYYY-MM-DD').format('YYYY-MM-DD')} ${e?.hour}:${e?.minutes}:${currentTimeinSec} ${e?.ampm}`
        const pickDt = moment(pickerDate, 'YYYY-MM-DD hh:mm:ss A').format('YYYY-MM-DD HH:mm:ss')
        const formattedpickerDate = getConvertedDate(pickDt)
        setPickerDateValue(formattedpickerDate)
        const diffRes = moment(formattedpickerDate).diff(moment(today), 'minutes')
        setBtnDisabled(props.hotel_type == '1' ? (Number(diffRes) < 1439) : moment(today).isSameOrAfter(formattedpickerDate, 'minutes')) //1440 is minuts of 24 hours
    }
    return (
        <div>
            {pickerValue.date ? 
            <Modal show={isScrollCalendarModal} onHide={() => setIsScrollCalendarModal(false)} centered className='commonModalDialogbox' animation={false}>
                <Modal.Header className='justify-content-around'><h5 className='text-primary'>{`Pick Date${props.hotel_type != '1' ? ' & Time':''}`}</h5></Modal.Header>
                <Modal.Body className='scrollable-Modal'>
                    <Picker wheel="normal" value={pickerValue} onChange={(e) => {
                        handleCustomDatePicker(e)
                    }} option={pickerValue}>
                        {selections.map((name, ind) => (
                            <Picker.Column key={'mapkey_'+ind} name={name.val}>
                                {name['mapkey'].map(option => (
                                    <Picker.Item key={option} value={option}>
                                        {props?.hotel_type == '1' ? <>{setStringData(option)?.day}, {setStringData(option)?.date}</> :setStringData(option)?.date}
                                    </Picker.Item>
                                ))}
                            </Picker.Column>
                        ))}
                    </Picker>
                </Modal.Body>
                <Modal.Footer className='flex-column'>
                    <h6 className='border w-100 rounded p-2 text-center'><div className='p-1'>
                        Exit By - {
                        pickerValue.date.includes('Today yearto') ? `${moment().format('MMM')} ${moment().tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').date()}, ${moment().year()} ${props.hotel_type != '1' ? moment().hour(pickerValue.hour).format('hh')+':'+moment().minutes(pickerValue.minutes).format('mm') : ''} ${props.hotel_type != '1' ? pickerValue.ampm : ''}`:
                        `${props?.hotel_type == '1' ? moment(pickerValue?.date?.split(' yearto ')?.join(' '), 'MMM DD YYYY')?.format('dddd') + ', ' : ''}${pickerValue?.date?.split(' yearto ')?.join(', ')} ${props?.hotel_type != '1' ? moment()?.hour(pickerValue?.hour)?.format('hh') +':'+moment().minutes(pickerValue.minutes).format('mm') : ''} ${props.hotel_type != '1' ? pickerValue.ampm : ''}`}
                    </div></h6>
                    
                    <button 
                        onClick={handleClick} 
                        disabled={btnDisabled}
                        style={props.partnerdetails ? {
                            backgroundColor: props.partnerdetails?.brand_setting?.color,
                            color: '#fff', borderColor: props.partnerdetails?.brand_setting?.color
                        } : {}}
                        className='btn btn-primary w-100 text-white'>Done</button>
                </Modal.Footer>
                {/* <span className='text-danger text-center mb-2' onClick={() => setIsScrollCalendarModal(false)}>Close</span> */}
            </Modal> : ''}
        </div>
    )
}

ScrollCalendar.propTypes = {
    dispatch: PropTypes.func,
    isScrollCalendarModal: PropTypes.bool,
    setIsScrollCalendarModal: PropTypes.func,
    isThisVehicleModal: PropTypes.bool,
    setEntryDateTime: PropTypes.func,
    handleEntryTime: PropTypes.func,
    setselctedDateTime: PropTypes.func,
    selctedDateTime: PropTypes.object,
    extend: PropTypes.bool,
    entryDateTime: PropTypes.string,
    isDateShow: PropTypes.bool,
    setSeletedRateBand: PropTypes.func,
    hotel_type: PropTypes.number,
    partnerdetails: PropTypes.object,
    startDate: PropTypes.string,
    selectedPastDate: PropTypes.string,
    ticketDetails: PropTypes.object,
}

ScrollCalendar.defaulProps = {
    dispatch: noop,
    isScrollCalendarModal: false,
    setIsScrollCalendarModal: noop,
    isThisVehicleModal: false,
    setEntryDateTime: noop,
    handleEntryTime: noop,
    setselctedDateTime: noop,
    selctedDateTime: EMPTY_OBJECT,
    extend: false,
    entryDateTime: '',
    isDateShow: false,
    setSeletedRateBand: noop,
    hotel_type: '0',
    partnerdetails: EMPTY_OBJECT,
    startDate: '',
    selectedPastDate: '',
    ticketDetails: EMPTY_OBJECT,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(ScrollCalendar)

